export default "__VITE_ASSET__Dn_o_aQE__"